import { graphql } from "gatsby";
import React, { FC, useMemo } from "react";

import { TagColors } from "../../forms/elements/tags/types";
import { HeroBanner, HeroBannerProps } from "../../strips/hero-banner";
import { HeroBannerVariants, JustifyText } from "../../strips/hero-banner/types";

export interface CustomerStoryStripProps extends Queries.CustomerStoryStripDataFragment {
  labels: Record<string, any>;
}

export const CustomerStoryStrip: FC<CustomerStoryStripProps> = ({
  bannerImage,
  bannerText,
  specialization,
  labels,
}) => {
  const tags = useMemo(() => {
    const tags: HeroBannerProps["pillTags"] = [];
    if (specialization?.machiningType?.material) {
      tags.push({
        color: specialization.machiningType.material as TagColors,
        children: labels?.[specialization.machiningType.material],
      });
    }
    if (specialization?.name) {
      tags.push({
        color: TagColors.Neutral,
        children: specialization.name,
      });
    }
    return tags;
  }, [labels, specialization?.machiningType?.material, specialization?.name]);

  return (
    <HeroBanner
      title={bannerText}
      tagVariant={HeroBannerVariants.h1}
      media={bannerImage as HeroBannerProps["media"]}
      pillTags={tags}
      abstract={null}
      showBiesseLogo={false}
      color={null}
      padded={false}
      justifyText={JustifyText.CENTER}
      card={null}
      anchors={null}
    />
  );
};

export const query = graphql`
  fragment CustomerStoryStripData on ContentfulCustomerStory {
    bannerImage {
      gatsbyImageData
      mimeType
    }
    defaultLocaleEntry {
      name
      specialization {
        name
        machiningType {
          material
        }
      }
    }
    bannerText
    specialization {
      name
      machiningType {
        material
      }
    }
    node_locale
  }
`;
